/**
 * Returns the full URL for an asset. If the value is already an absolute URL,
 * it is returned as-is. Otherwise it is routed through the asset proxy.
 */
export const getAssetUrl = (path: string | null | undefined): string => {
  if (!path) return '';

  return path.startsWith('https://') || path.startsWith('http://') || path.startsWith('/api/v1')
    ? path
    : `/api/v1/public/assets/proxy?object=${path}`;
};
